export default "https://d3fbpisbzpk8wt.cloudfront.net/2026512124252/receiptScanNgOutOfFocus-bundle-45ec6c040539fa9e92d017d90f14df31.png";